import React from "react";
import { Button } from "@mui/material";
import { Tooltip } from "../Tooltip";
import { PropTypes } from "prop-types";

const TooltipButton = ({ tooltipProps, children, ...buttonProps }) => (
  <Tooltip {...tooltipProps}>
    <div>
      <Button {...buttonProps}>{children}</Button>
    </div>
  </Tooltip>
);

export default TooltipButton;

TooltipButton.propTypes = {
  children: PropTypes.node,
  /**
   * Props that will be passed to the tooltip component
   */
  tooltipProps: PropTypes.object
};

TooltipButton.defaultProps = {
  color: "primary",
  variant: "contained"
};
